import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAppContext();
  const location = useLocation();

  console.log('🔒 ProtectedRoute check:', { isAuthenticated, loading });

  if (loading) {
    console.log('⏸️  ProtectedRoute: Still loading, showing loading screen');
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      }}>
        <div style={{ 
          color: 'white', 
          fontSize: '18px',
          textAlign: 'center'
        }}>
          <div style={{ 
            border: '4px solid rgba(255,255,255,0.3)',
            borderTop: '4px solid white',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 16px'
          }}></div>
          Loading...
        </div>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (!isAuthenticated) {
    console.log('❌ ProtectedRoute: Not authenticated, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  const isTestUser = user && (user.email === 'dev@example.com' || user.userId === 'dev-user-123');
  const isOnboardingFlow = location.pathname.startsWith('/onboarding-questions');
  const onboardingCompleted = user && (user.onboardingCompleted === true || user.onboardingCompleted === 1 || user.onboardingCompleted === '1');

  // All users: redirect to onboarding questions if not completed
  if (user && !onboardingCompleted && !isOnboardingFlow) {
    console.log('⚠️ ProtectedRoute: User has not completed onboarding questions, redirecting to /onboarding-questions');
    return <Navigate to="/onboarding-questions" replace />;
  }

  if (user && isTestUser) {
    // Test user with onboarding completed: allow access (skip role setup)
    console.log('✅ ProtectedRoute: Authenticated, rendering children');
    return children;
  }

  // Defence: skip role setup entirely — go to onboarding or prompt library only
  const isDefence = typeof window !== 'undefined' && window.location.hostname.includes('defenceframework');
  if (isDefence) {
    console.log('✅ ProtectedRoute: Defence user, skipping role setup');
    return children;
  }

  // No welcome flow: new users go straight to onboarding only (welcome/role setup skipped to avoid loop)

  console.log('✅ ProtectedRoute: Authenticated, rendering children');
  return children;
};

export default ProtectedRoute;

